// =========================================================
// MENU CRITIQUE — entry séparé chargé en EAGER (exclu du Delay JS WP Rocket).
// Contient Bootstrap Offcanvas/Collapse (data-API du burger) + les utilities
// du menu mobile, pour que le menu réponde IMMÉDIATEMENT sans attendre le
// bundle principal (script.js, délayé pour le score CWV).
// =========================================================
import {Collapse, Offcanvas} from 'bootstrap';

require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/km_mobile_menu.js'); // accordéons du menu mobile custom + scroll lock
